import React, { useEffect, useState } from "react";
import * as func from "../../../common/athleteCommon/FunctionCalls";
import ImageWithBasePath from "../../../../core/data/img/ImageWithBasePath";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const HPCBatchAthlete = () => {
    
    const [batchAthleteList, setBatchAthleteList] = useState<any[]>([]);
    const [searchInput, setSearchInput] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    
    useEffect(() => {
        async function fetchBatchAthletes() {
            setIsLoading(true);
            const batchAthleteResponse = await func.hpcBatchAthelete(null);
            setBatchAthleteList(Array.isArray(batchAthleteResponse) ? batchAthleteResponse : [])
            setIsLoading(false);
        }
        fetchBatchAthletes();
    }, [])

    const filteredData = batchAthleteList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const batchNameRender = (rowData) => {
        return <span>{rowData.batchName}</span>;
    };

    const athleteNameRender = (rowData) => {
        return <span>{rowData.athleteName}</span>;
    };

    const batchAthleteStatusRender = (rowData) => {
        return <span>{(rowData.batchAthleteStatus == 1) ? "Active" : "Inactive"}</span>;

    };


    return (
        <>
            {isLoading && (

                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1380px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Batch Athletes</h4>
                                </div>
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="batchName"
                                                header="Batch Name"
                                                body={batchNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="athleteName"
                                                header="Athlete Name"
                                                body={athleteNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="batchAthleteStatus"
                                                header="Batch Athlete Status"
                                                body={batchAthleteStatusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HPCBatchAthlete;